export default __webpack_public_path__ + "static/media/ic_me2u.8c468a9e.svg";